/* API */
let auth_url_config = '';
let api_url_config = '';
let api2_url_config = '';

console.log(window.location.hostname);

if(window.location.hostname==='test.proequidad.inmujeres.gob.mx' || window.location.hostname==='proequidad2019.inmujeres.gob.mx') {
	auth_url_config = 'http://api.proequidad.inmujeres.gob.mx';
	api_url_config = 'http://api.proequidad.inmujeres.gob.mx/api/v1';
	api2_url_config = 'http://api.proequidad.inmujeres.gob.mx/api/v2';
} else if(window.location.hostname==='proequidad.qa.cantaloop.mx') {
	auth_url_config = 'http://api.proequidad.qa.cantaloop.mx';
	api_url_config = 'http://api.proequidad.qa.cantaloop.mx/api/v1';
	api2_url_config = 'http://api.proequidad.qa.cantaloop.mx/api/v2';
} else if(window.location.hostname==='proequidad.dev.cantaloop.mx') {
	auth_url_config = 'http://api.proequidad.dev.cantaloop.mx';
	api_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v1';
	api2_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v2';
} 
else if(window.location.hostname==="proequidadqa.inmujeres.gob.mx"){
	auth_url_config = 'https://proequidadqa.inmujeres.gob.mx/api';
	api_url_config = 'https://proequidadqa.inmujeres.gob.mx/api/api/v1';
	api2_url_config = 'https://proequidadqa.inmujeres.gob.mx/api/api/v2';
}
else {
	auth_url_config = 'https://proequidadqa.inmujeres.gob.mx/api';
	api_url_config = 'https://proequidadqa.inmujeres.gob.mx/api/api/v1';
	api2_url_config = 'https://proequidadqa.inmujeres.gob.mx/api/api/v2';
	// auth_url_config = 'http://api.proequidad.dev.cantaloop.mx';
	// api_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v1';
	// api2_url_config = 'http://api.proequidad.dev.cantaloop.mx/api/v2';
}
export const AUTH_URL = auth_url_config;
export const API_URL = api_url_config;
export const API2_URL = api2_url_config;
export const ACERVO_URL = api2_url_config + '/acervo';

/* LOGIN */
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_OK = 'LOGIN_OK';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_AGENCIES = 'LOGIN_AGENCIES';
export const LOGIN_CDMS = 'LOGIN_CDMS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const FORGOT_REQUEST = 'FORGOT_REQUEST';
export const FORGOT_OK = 'FORGOT_OK';
export const RESET_REQUEST = 'RESET_REQUEST';
export const RESET_OK = 'RESET_OK';

/*REGISTER*/
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_VALIDATE = 'REGISTER_VALIDATE';
export const REGISTER_NOT_VALIDATE = 'REGISTER_NOT_VALIDATE';
export const REGISTER_COMPLETE = 'REGISTER_COMPLETE';
export const REGISTER_FAIL = 'REGISTER_FAIL';

/* USER PROFILE */
export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_SHOW = 'PROFILE_SHOW';
export const PROFILE_AGENCIES = 'PROFILE_AGENCIES';
export const PROFILE_FAIL = 'PROFILE_FAIL';

/* MENU */
export const MENU_SHOW = 'MENU_SHOW';
export const MENU_HIDE = 'MENU_HIDE';

/* USERS */
export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_FAIL = 'USERS_FAIL';
export const USERS_SHOW = 'USERS_SHOW';
export const USER_EDIT = 'USER_EDIT';
export const USER_ROLE = 'USER_ROLE';
export const USER_AGENCIES = 'USER_AGENCIES';
export const USER_COMPLETE = 'USER_COMPLETE';
export const USER_CLEAR = 'USER_CLEAR';
export const USER_SET_SEARCH = 'USER_SET_SEARCH';

/* PERMISSIONS */
export const PERMISSION_REQUEST ='PERMISSION_REQUEST';
export const PERMISSIONS_SHOW = 'PERMISSIONS_SHOW';
export const PERMISSIONS_LIST = 'PERMISSIONS_LIST';
export const PERMISSIONS_EDIT = 'PERMISSIONS_EDIT';
export const PERMISSIONS_CLEAR = 'PERMISSIONS_CLEAR';
export const PERMISSIONS_DELETE = 'PERMISSIONS_DELETE';
export const PERMISSION_FAIL = 'PERMISSION_FAIL';

/* VERSIONS */
export const VERSIONS_REQUEST = 'VERSIONS_REQUEST';
export const VERSIONS_SHOW = 'VERSIONS_SHOW';
export const VERSIONS_LIST = 'VERSIONS_LIST';
export const VERSIONS_FAIL = 'VERSIONS_FAIL';
export const VERSION_EDIT = 'VERSION_EDIT';
export const VERSION_CLEAR = 'VERSION_CLEAR';

/*VERSION GROUPS PHASES*/
export const VERSION_GROUPS_PHASES_REQUEST = 'VERSION_GROUPS_PHASES_REQUEST';
export const VERSION_GROUPS_PHASES_EDIT = 'VERSION_GROUPS_PHASES_EDIT';
export const VERSION_GROUPS_PHASES_CLEAR = 'VERSION_GROUPS_PHASES_CLEAR';
export const VERSION_GROUPS_PHASES_FAIL = 'VERSION_GROUPS_PHASES_FAIL';

/* PHASES */
export const PHASES_REQUEST = 'PHASES_REQUEST';
export const PHASES_SHOW = 'PHASES_SHOW';
export const PHASES_LIST = 'PHASES_LIST';
export const PHASE_EDIT = 'PHASE_EDIT';
export const PHASES_FAIL = 'PHASES_FAIL';

/* GROUPS PHASES */
export const GROUPS_PHASES_REQUEST = 'GROUPS_PHASES_REQUEST'
export const GROUPS_PHASES_LIST = 'GROUPS_PHASES_LIST'
export const GROUPS_PHASES_EDIT = 'GROUPS_PHASES_EDIT'
export const GROUPS_PHASES_CLEAR = 'GROUPS_PHASES_CLEAR'
export const GROUPS_PHASES_FAIL = 'GROUPS_PHASES_FAIL'

/*DOCUMENTS TYPES*/
export const DOCUMENTS_TYPES_REQUEST = 'DOCUMENTS_TYPES_REQUEST';
export const DOCUMENTS_TYPES = 'DOCUMENTS_TYPES';
export const DOCUMENTS_TYPES_EDIT = 'DOCUMENTS_TYPES_EDIT';
export const DOCUMENTS_TYPES_FAIL = 'DOCUMENTS_TYPES_FAIL';

/* ROLES */
export const ROLES_REQUEST = 'ROLES_REQUEST';
export const ROLES_SHOW = 'ROLES_SHOW';
export const ROLES_LIST = 'ROLES_LIST';
export const ROLE_EDIT = 'ROLE_EDIT';
export const ROLE_PERMISSIONS = 'ROLE_PERMISSIONS';
export const ROLES_DELETE = 'ROLES_DELETE';
export const ROLES_COMPLETE = 'ROLES_COMPLETE';
export const ROLES_CLEAR = 'ROLES_CLEAR';
export const ROLE_FAIL = 'ROLE_FAIL';

/* PROIGUALDAD GOALS*/
export const GOALS_REQUEST = 'GOALS_REQUEST';
export const GOALS_SHOW = 'GOALS_SHOW';
export const GOALS_FETCH = 'GOALS_FETCH';
export const GOAL_EDIT = 'GOAL_EDIT';
export const GOAL_ACTIVITIES = 'GOAL_ACTIVITIES';
export const GOAL_COMPLETE = 'GOAL_COMPLETE';
export const GOAL_DELETE = 'GOAL_DELETE';
export const GOAL_CLEAR = 'GOAL_CLEAR';
export const GOAL_FAIL = 'GOAL_FAIL';

/*PROIGUALDAD AXIS */
export const AXIS_REQUEST = 'AXIS_REQUEST';
export const AXIS_SHOW = 'AXIS_SHOW';
export const AXIS_EDIT = 'AXIS_EDIT';
export const AXIS_CLEAR = 'AXIS_CLEAR';
export const AXIS_FAIL = 'AXIS_FAIL';

/*PROIGUALDAD LINES */
export const LINES_REQUEST = 'LINES_REQUEST';
export const LINES_SHOW = 'LINES_SHOW';
export const LINES_EDIT = 'LINES_EDIT';
export const LINES_CLEAR = 'LINES_CLEAR';
export const LINES_FAIL = 'LINES_FAIL';
export const LINES_COMPLETE = 'LINES_COMPLETE';

/*PROIGUALDAD OBJECTIVES*/
export const OBJECTIVES_REQUEST = 'OBJECTIVES_REQUEST';
export const OBJECTIVES_SHOW = 'OBJECTIVES_SHOW';
export const OBJECTIVES_EDIT = 'OBJECTIVES_EDIT';
export const OBJECTIVES_CLEAR = 'OBJECTIVES_CLEAR';
export const OBJECTIVES_FAIL = 'OBJECTIVES_FAIL';

/*PROIGUALDAD STRATEGIES*/
export const STRATEGIES_REQUEST = 'STRATEGIES_REQUEST';
export const STRATEGIES_SHOW = 'STRATEGIES_SHOW';
export const STRATEGIES_EDIT = 'STRATEGIES_EDIT';
export const STRATEGIES_CLEAR = 'STRATEGIES_CLEAR';
export const STRATEGIES_FAIL = 'STRATEGIES_FAIL';

/* STATUS */
export const STATUS_REQUEST = 'STATUS_REQUEST';
export const STATUS_FETCH = 'STATUS_FETCH';
export const STATUS_FAIL = 'STATUS_FAIL';
export const STATUS_GROUP = 'STATUS_GROUP';

/*ACTIVITIES*/
export const ACTIVITY_REQUEST = 'ACTIVITY_REQUEST';
export const ACTIVITIES_SHOW = 'ACTIVITIES_SHOW';
export const ACTIVITIES_LIST = 'ACTIVITIES_LIST';
export const ACTIVITY_EDIT = 'ACTIVITY_EDIT';
export const ACTIVITY_VERIFICATION_MEDIA = 'ACTIVITY_VERIFICATION_MEDIA';
export const ACTIVITY_COMPLETE = 'ACTIVITY_COMPLETE';
export const ACTIVITY_CLEAR = 'ACTIVITY_CLEAR';
export const ACTIVITY_FAIL = 'ACTIVITY_FAIL';

/*ACTIVITIES GROUPS*/
export const ACTIVITY_GROUP_REQUEST = 'ACTIVITY_GROUP_REQUEST';
export const ACTIVITY_GROUP_SHOW = 'ACTIVITY_SHOW';
export const ACTIVITY_GROUP_FAIL = 'ACTIVITY_FAIL';

/*CONCEPTS*/
export const CONCEPTS_REQUEST = 'CONCEPTS_REQUEST';
export const CONCEPTS_COMPLETE = 'CONCEPTS_COMPLETE';
export const CONCEPTS_SHOW = 'CONCEPTS_SHOW';
export const CONCEPT_EDIT = 'CONCEPT_EDIT';
export const CONCEPT_UNITS = 'CONCEPT_UNITS';
export const CONCEPT_CLEAR = 'CONCEPT_CLEAR';
export const CONCEPT_FAIL = 'CONCEPT_FAIL';

/*UNITS*/
export const UNIT_REQUEST = 'UNIT_REQUEST';
export const UNITS_SHOW = 'UNIT_SHOW';
export const UNIT_EDIT = 'UNIT_EDIT';
export const UNIT_FAIL = 'UNIT_FAIL';

/*VERIFICATION-MEDIA*/
export const VERIFICATION_MEDIA_SHOW = 'VERIFICATION_MEDIA_SHOW';
export const VERIFICATION_MEDIA_REQUEST = 'VERIFICATION_MEDIA_REQUEST';
export const VERIFICATION_MEDIA_FAIL = 'VERIFICATION_MEDIA_FAIL';

/*MODAL*/
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const MODAL_NOTIFICATION_SET = 'MODAL_NOTIFICATION_SET';
export const MODAL_NOTIFICATION_CLEAR = 'MODAL_NOTIFICATION_CLEAR';

/* NOTIFICATIONS */
export const NOTIFICATION_SET = 'NOTIFICATION_SET';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';

/* STATES */
export const ENTITIES_REQUEST = 'ENTITIES_REQUEST';
export const ENTITIES_SHOW = 'ENTITIES_SHOW';
export const ENTITIES_FETCH = 'ENTITIES_FETCH';
export const ENTITIES_EDIT = 'ENTITIES_EDIT';
export const ENTITIES_FAIL = 'ENTITIES_FAIL';

/* MUNICIPALITIES */
export const MUNICIPALITIES_REQUEST = 'MUNICIPALITIES_REQUEST';
export const MUNICIPALITIES_SHOW = 'MUNICIPALITIES_SHOW';
export const MUNICIPALITIES_FETCH = 'MUNICIPALITIES_FETCH';
export const MUNICIPALITIES_EDIT = 'MUNICIPALITIES_EDIT';
export const MUNICIPALITIES_FAIL = 'MUNICIPALITIES_FAIL';
export const MUNICIPALITIES_FILTERED = 'MUNICIPALITIES_FILTERED';

/* AGENCIES */
export const AGENCIES_REQUEST = 'AGENCIES_REQUEST';
export const AGENCIES_SHOW = 'AGENCIES_SHOW';
//export const AGENCIES_FETCH = 'AGENCIES_FETCH';
export const AGENCIES_EDIT = 'AGENCIES_EDIT';
export const AGENCIES_COMPLETE = 'AGENCIES_COMPLETE';
export const AGENCIES_FAIL = 'AGENCIES_FAIL';

/*AGENCIES MUNICIPALITIES*/
export const AGENCIES_MUNICIPALITIES_REQUEST = 'AGENCIES_MUNICIPALITIES_REQUEST';
export const AGENCIES_MUNICIPALITIES_FETCH = 'AGENCIES_MUNICIPALITIES_FETCH';


/*AMOUNTS AGENCIES*/
export const AMOUNTS_AGENCIES_REQUEST = 'AMOUNTS_AGENCIES_REQUEST';
export const AMOUNTS_AGENCIES_SHOW = 'AMOUNTS_AGENCIES_SHOW';
export const AMOUNTS_AGENCIES_EDIT = 'AMOUNTS_AGENCIES_EDIT';
export const AMOUNTS_AGENCIES_COMPLETE = 'AMOUNTS_AGENCIES_COMPLETE';
export const AMOUNTS_AGENCIES_FAIL = 'AMOUNTS_AGENCIES_FAIL';

/* PROJECTS CRUD */
export const PROJECTS_REQUEST = 'PROJECTS_REQUEST';
export const PROJECTS_FETCH = 'PROJECTS_FETCH';
export const PROJECTS_LIST = 'PROJECTS_LIST';
export const PROJECTS_EDIT = 'PROJECTS_EDIT';
export const PROJECTS_GOALS = 'PROJECTS_GOALS';
export const PROJECTS_EXPENSES = 'PROJECTS_EXPENSES';
export const PROJECTS_EMPLOYEES = 'PROJECTS_EMPLOYEES';
export const PROJECTS_EMPLOYEES_EDIT = 'PROJECTS_EMPLOYEES_EDIT';
export const PROJECTS_COMMISSIONS = 'PROJECTS_COMMISSIONS';
export const PROJECTS_PHASES_GROUPS = 'PROJECTS_PHASES_GROUPS';
export const PROJECTS_PHASES_GROUPS_EDIT = 'PROJECTS_PHASES_GROUPS_EDIT';
//export const PROJECTS_COMMISSION = 'PROJECTS_COMMISSION';
export const PROJECTS_EDIT_REQUEST = 'PROJECTS_EDIT_REQUEST';
export const PROJECT_SET_SEARCH = 'PROJECT_SET_SEARCH';
//export const PROJECT_CHANGE_TAB_DATA = 'PROJECT_CHANGE_TAB_DATA';
export const PROJECTS_FOLIOS = 'PROJECTS_FOLIOS';
export const PROJECTS_COMPLETE = 'PROJECTS_COMPLETE';
export const PROJECTS_CLEAR = 'PROJECTS_CLEAR';
export const PROJECTS_FAIL = 'PROJECTS_FAIL';

/* PROJECTS REGISTER */
export const PROJECT_REQUEST = 'PROJECT_REQUEST';
export const PROJECT_CLEAR = 'PROJECT_CLEAR';
export const PROJECT_FAIL = 'PROJECT_FAIL';
export const PROJECT_LOADED = 'PROJECT_LOADED';
export const PROJECT_OWNER = 'PROJECT_OWNER';
export const PROJECT_OWNER_REQUEST = 'PROJECT_OWNER_REQUEST';
export const PROJECT_OWNER_FAIL = 'PROJECT_OWNER_FAIL';
export const PROJECT_OWNER_CLEAR = 'PROJECT_OWNER_CLEAR';
export const PROJECT_INSTANCE = 'PROJECT_INSTANCE';
export const PROJECT_INSTANCE_REQUEST = 'PROJECT_INSTANCE_REQUEST';
export const PROJECT_INSTANCE_LOADED = 'PROJECT_INSTANCE_LOADED';
export const PROJECT_INSTANCE_FAIL = 'PROJECT_INSTANCE_FAIL';
export const PROJECT_INSTANCE_CLEAR = 'PROJECT_INSTANCE_CLEAR';
export const PROJECT_REGISTRY = 'PROJECT_REGISTRY';
export const PROJECT_REGISTRY_REQUEST = 'PROJECT_REGISTRY_REQUEST';
export const PROJECT_REGISTRY_FAIL = 'PROJECT_REGISTRY_FAIL';
export const PROJECT_REGISTRY_CLEAR = 'PROJECT_REGISTRY_CLEAR';
export const PROJECT_REGISTRY_DATA = 'PROJECT_REGISTRY_DATA';
export const PROJECT_REGISTRY_DATA_REQUEST = 'PROJECT_REGISTRY_DATA_REQUEST';
export const PROJECT_REGISTRY_DATA_FAIL = 'PROJECT_REGISTRY_DATA_FAIL';
export const PROJECT_REGISTRY_LOADED = 'PROJECT_REGISTRY_LOADED';
export const PROJECT_PROIGUALDAD_GOALS_REQUEST = 'PROJECT_PROIGUALDAD_GOALS_REQUEST';
export const PROJECT_PROIGUALDAD_GOALS_COMPLETE = 'PROJECT_PROIGUALDAD_GOALS_COMPLETE';
export const PROJECT_PROIGUALDAD_GOALS = 'PROJECT_PROIGUALDAD_GOALS';
export const PROJECT_PROIGUALDAD_GOALS_EDIT = 'PROJECT_PROIGUALDAD_GOALS_EDIT';
export const PROJECT_PROIGUALDAD_GOALS_CLEAR = 'PROJECT_PROIGUALDAD_GOALS_CLEAR';
export const PROJECT_PROIGUALDAD_GOALS_FAIL = 'PROJECT_PROIGUALDAD_GOALS_FAIL';
export const PROJECT_EXPENSES_REQUEST = 'PROJECT_EXPENSES_REQUEST';
export const PROJECT_EXPENSES = 'PROJECT_EXPENSES';
export const PROJECT_EXPENSES_CLEAR = 'PROJECT_EXPENSES_CLEAR';
export const PROJECT_EXPENSES_FAIL = 'PROJECT_EXPENSES_FAIL';
export const PROJECT_EMPLOYEES = 'PROJECT_EMPLOYEES';
export const PROJECT_EMPLOYEES_REQUEST = 'PROJECT_EMPLOYEES_REQUEST';
export const PROJECT_EMPLOYEES_EDIT_REQUEST = 'PROJECT_EMPLOYEES_EDIT_REQUEST';
export const PROJECT_EMPLOYEES_FAIL = 'PROJECT_EMPLOYEES_FAIL';
//export const PROJECT_EMPLOYEES_ROLES = 'PROJECT_EMPLOYEES_ROLES';
export const PROJECT_EMPLOYEES_CLEAR = 'PROJECT_EMPLOYEES_CLEAR';
export const PROJECT_CONCLUSION = 'PROJECT_CONCLUSION';
export const PROJECT_CONCLUSION_LOADED = 'PROJECT_CONCLUSION_LOADED';
export const PROJECT_CONCLUSION_REQUEST = 'PROJECT_CONCLUSION_REQUEST';
export const PROJECT_CONCLUSION_CLEAR = 'PROJECT_CONCLUSION_CLEAR';
export const PROJECT_CONCLUSION_FAIL = 'PROJECT_CONCLUSION_FAIL';

/*PROJECT AGREEMENTS*/
export const PROJECT_AGREEMENTS_REQUEST = 'PROJECT_AGREEMENTS_REQUEST';
export const PROJECT_AGREEMENTS = 'PROJECT_AGREEMENTS';
export const PROJECT_AGREEMENTS_LOADED = 'PROJECT_AGREEMENTS_LOADED';
export const PROJECT_AGREEMENTS_FAIL = 'PROJECT_AGREEMENTS_FAIL';
export const PROJECT_AGREEMENTS_CLEAR = 'PROJECT_AGREEMENTS_CLEAR';

/*PROJECT TRACING AGREEMENTS DISPERSIONS*/
export const PROJECT_DISPERSIONS = 'PROJECT_DISPERSIONS';
export const PROJECT_DISPERSIONS_REQUEST = 'PROJECT_DISPERSIONS_REQUEST';
export const PROJECT_DISPERSIONS_LOADED = 'PROJECT_DISPERSIONS_LOADED';
export const PROJECT_DISPERSIONS_CLEAR = 'PROJECT_DISPERSIONS_CLEAR';
export const PROJECT_DISPERSIONS_FAIL = 'PROJECT_DISPERSIONS_FAIL';

/*DIRECTORIES*/
export const DIRECTORIES_REQUEST = 'DIRECTORIES_CONAGO_REQUEST';
export const DIRECTORIES_CONAGO_FETCH = 'DIRECTORIES_CONAGO_FETCH';
export const DIRECTORIES_ACTORS_FETCH = 'DIRECTORIES_ACTORS_FETCH';
export const DIRECTORIES_ACTORS_GROUPS_FETCH = 'DIRECTORIES_ACTORS_GROUPS_FETCH';
export const DIRECTORIES_FAIL = 'DIRECTORIES_ACTORS_FAIL';

/* RESOURCE_CONCEPT */
export const RESOURCE_CONCEPT_REQUEST = 'RESOURCE_CONCEPT_REQUEST';
export const RESOURCE_CONCEPT_FETCH = 'RESOURCE_CONCEPT_FETCH';
export const RESOURCE_CONCEPT_FAIL = 'RESOURCE_CONCEPT_FAIL';

/* REVISION */
export const REVISION_REQUEST = 'REVISION_REQUEST';
export const REVISION_OWNER = 'REVISION_OWNER';
export const REVISION_INSTANCE = 'REVISION_INSTANCE';
export const REVISION_REGISTRY = 'REVISION_REGISTRY';
export const REVISION_EXPENSES = 'REVISION_EXPENSES';
export const REVISION_PROFILES = 'REVISION_PROFILES';
export const REVISION_CONCLUSION = 'REVISION_CONCLUSION';
export const REVISION_CONCLUSION_EDIT = 'REVISION_CONCLUSION_EDIT';
export const REVISION_AGREEMENTS_ADMIN = 'REVISION_AGREEMENTS_ADMIN';
export const REVISION_AGREEMENTS_ADMIN_EDIT = 'REVISION_AGREEMENTS_ADMIN_EDIT';
export const REVISION_AGREEMENTS_LEGAL = 'REVISION_AGREEMENTS_LEGAL';
export const REVISION_AGREEMENTS_LEGAL_EDIT = 'REVISION_AGREEMENTS_LEGAL_EDIT';
export const REVISION_REPORTS_FINANCIAL = 'REVISION_REPORTS_FINANCIAL';
export const REVISION_REPORTS_EXPENSES = 'REVISION_REPORTS_EXPENSES';
export const REVISION_REPORTS_SUMMARY = 'REVISION_REPORTS_SUMMARY';
export const REVISION_COMMISSION = 'REVISION_COMMISSION';
//export const REVISION_COMMISSION_SAVE = 'REVISION_COMMISSION_SAVE';
export const REVISION_COMMISSION_CLEAR = 'REVISION_COMMISSION_CLEAR';
export const REVISION_FAIL = 'REVISION_FAIL';
export const REVISION_CLEAR = 'REVISION_CLEAR';
export const REVISION_COMPLETE = 'REVISION_COMPLETE';

/*MODALITIES*/
export const MODALITIES_REQUEST = 'MODALITIES_REQUEST';
export const MODALITIES_FETCH = 'MODALITIES_FETCH';
export const MODALITIES_FAIL = 'MODALITIES_FAIL';

/*NOTIFICATION MESSAGES*/
export const NOTIFICATION_MESSAGES_REQUEST = 'NOTIFICATION_MESSAGES_REQUEST';
export const NOTIFICATION_MESSAGES_COMPLETE = 'NOTIFICATION_MESSAGES_COMPLETE';
export const NOTIFICATION_STATES_REQUEST = 'NOTIFICATION_STATES_REQUEST';
export const NOTIFICATION_STATES_SAVE = 'NOTIFICATION_STATES_SAVE';
export const NOTIFICATION_MESSAGES_FETCH = 'NOTIFICATION_MESSAGES_FETCH';
export const NOTIFICATION_MESSAGES_FAIL = 'NOTIFICATION_MESSAGES_FAIL';
export const NOTIFICATION_MESSAGES_CLEAR = 'NOTIFICATION_MESSAGES_CLEAR';
export const NOTIFICATION_TYPES_FETCH = 'NOTIFICATION_TYPES_FETCH';

/*NOTIFICATIONS TYPES*/
export const NOTIFICATION_TYPE_REQUEST = 'NOTIFICATION_TYPE_REQUEST';
export const NOTIFICATION_TYPE_SHOW = 'NOTIFICATION_TYPE_SHOW';
export const NOTIFICATION_TYPE_EDIT = 'NOTIFICATION_TYPE_EDIT';
export const NOTIFICATION_TYPE_CLEAR = 'NOTIFICATION_TYPE_CLEAR';
export const NOTIFICATION_TYPE_FAIL = 'NOTIFICATION_TYPE_FAIL';

/*SURVEYS*/
export const SURVEYS_REQUEST = 'SURVEYS_REQUEST';
export const SURVEYS_TYPES_REQUEST = 'SURVEYS_TYPES_REQUEST';
export const SURVEYS_FETCH = 'SURVEYS_FETCH';
export const SURVEYS_FETCH_LIST = 'SURVEYS_FETCH_LIST';
export const SURVEYS_FETCH_TYPES = 'SURVEYS_FETCH_TYPES';
export const SURVEYS_EDIT = 'SURVEYS_EDIT';
export const SURVEYS_QUESTIONS_EDIT = 'SURVEYS_QUESTIONS_EDIT';
export const SURVEYS_CLEAR = 'SURVEYS_CLEAR';
export const SURVEYS_COMPLETE = 'SURVEYS_COMPLETE';
export const SURVEYS_FAIL = 'SURVEYS_FAIL';

//REPORTS;
//export const REPORTS_REQUEST = 'REPORTS_REQUEST';
export const REPORTS_FINANCIAL = 'REPORTS_FINANCIAL';
export const REPORTS_FINANCIAL_GOAL = 'REPORTS_FINANCIAL_GOAL';
export const REPORTS_FINANCIAL_ACTIVITY = 'REPORTS_FINANCIAL_ACTIVITY';
export const REPORTS_FINANCIAL_EDIT_REQUEST = 'REPORTS_FINANCIAL_EDIT_REQUEST';
export const REPORTS_FINANCIAL_EDIT_FAIL = 'REPORTS_FINANCIAL_EDIT_FAIL';
export const REPORTS_FINANCIAL_EDIT_INVOICE_FAIL = 'REPORTS_FINANCIAL_EDIT_INVOICE_FAIL';
export const REPORTS_FINANCIAL_REQUEST = 'REPORTS_FINANCIAL_REQUEST';
export const REPORTS_FINANCIAL_CLEAR = 'REPORTS_FINANCIAL_CLEAR';
export const REPORTS_FINANCIAL_FAIL = 'REPORTS_FINANCIAL_FAIL';
export const REPORTS_EXPENSES = 'REPORTS_EXPENSES';
export const REPORTS_EXPENSES_EDIT = 'REPORTS_EXPENSES_EDIT';
export const REPORTS_EXPENSES_EDIT_REQUEST = 'REPORTS_EXPENSES_EDIT_REQUEST';
export const REPORTS_EXPENSES_EDIT_FAIL = 'REPORTS_EXPENSES_EDIT_FAIL';
export const REPORTS_EXPENSES_REQUEST = 'REPORTS_EXPENSES_REQUEST';
export const REPORTS_EXPENSES_CLEAR = 'REPORTS_EXPENSES_CLEAR';
export const REPORTS_EXPENSES_FAIL = 'REPORTS_EXPENSES_FAIL';
export const REPORTS_EMPLOYEES = 'REPORTS_EMPLOYEES';
export const REPORTS_EMPLOYEES_EDIT = 'REPORTS_EMPLOYEES_EDIT';
export const REPORTS_EMPLOYEES_EDIT_REQUEST = 'REPORTS_EMPLOYEES_EDIT_REQUEST';
export const REPORTS_EMPLOYEES_EDIT_FAIL = 'REPORTS_EMPLOYEES_EDIT_FAIL';
export const REPORTS_EMPLOYEES_REQUEST = 'REPORTS_EMPLOYEES_REQUEST';
export const REPORTS_EMPLOYEES_CLEAR = 'REPORTS_EMPLOYEES_CLEAR';
export const REPORTS_EMPLOYEES_FAIL = 'REPORTS_EMPLOYEES_FAIL';
export const REPORTS_SUMMARY = 'REPORTS_SUMMARY';
export const REPORTS_SUMMARY_REQUEST = 'REPORTS_SUMMARY_REQUEST';
export const REPORTS_SUMMARY_CLEAR = 'REPORTS_SUMMARY_CLEAR';
export const REPORTS_SUMMARY_FAIL = 'REPORTS_SUMMARY_FAIL';
export const REPORTS_SUMMARY_COMPLETE = 'REPORTS_SUMMARY_COMPLETE';
export const REPORTS_SURVEYS = 'REPORTS_SURVEYS';
export const REPORTS_SURVEYS_REQUEST = 'REPORTS_SURVEYS_REQUEST';
export const REPORTS_SURVEYS_CLEAR = 'REPORTS_SURVEYS_CLEAR';
export const REPORTS_SURVEYS_FAIL = 'REPORTS_SURVEYS_FAIL';
//export const REPORTS_SURVEYS_COMPLETE = 'REPORTS_SURVEYS_COMPLETE';
//export const REPORTS_FAIL = 'REPORTS_FAIL';*/

export const CDM_REQUEST = 'CDM_REQUEST';
export const CDM_EMPLOYEES = 'CDM_EMPLOYEES';
export const CDM_CLEAR = 'CDM_CLEAR';
export const CDM_FAIL = 'CDM_FAIL';

/* PASOS CAPTURA DE PROYECTO */
/* @todo: No sé si esto esté bien hardcodeado aquí, pero lo voy a poner en las configuraciones a menos que veamos que sea prudende hacer un endpoint o algo */

export const projectInitNav = [
	{step: 1, url: '/proyecto/:modality/titular/:state?/:municipality?', title: 'Datos del Titular'},
	{step: 2, url: '/proyecto/:modality/instancia/:state?/:municipality?', title: 'Datos de la Instancia'},
	{step: 3, url: '/proyecto/:modality/metas/:state?/:municipality?', title: 'Datos del Proyecto'},
	{step: 4, url: '/proyecto/:modality/gastos/:state?/:municipality?', title: 'Gastos de Coordinación'},
	{step: 5, url: '/proyecto/:modality/adicionales/:state?/:municipality?', title: 'Datos Adicionales'},
	{step: 6, url: '/proyecto/:modality/conclusion/:state?/:municipality?', title: 'Conclusión'}
]

export const projectsEditInitNav = [
	{step: 1, url: '/proyectos/editar/datos/:id', title: 'Administrar información del proyecto'},
	{step: 2, url: '/proyectos/editar/metas/:id', title: 'Administrar metas del proyecto'},
	{step: 3, url: '/proyectos/editar/gastos/:id', title: 'Administrar gastos de coordinación'},
	{step: 4, url: '/proyectos/editar/personal/:id', title: 'Administrar personal'},
	{step: 5, url: '/proyectos/editar/encuesta-comisiones/:id', title: 'Encuesta de comisiones'},
	{step: 6, url: '/proyectos/editar/procesos/:id', title: 'Administrar procesos'}
]

export const reportsInitNav = [
	{step: 1, url: '/informes/:modality/avance-fisico-financiero/:state?/:municipality?', title: 'Avance físico financiero'},
	{step: 2, url: '/informes/:modality/gastos-coordinacion/:state?/:municipality?', title: 'Gastos de coordinación'},
	{step: 3, url: '/informes/:modality/personas-contratadas/:state?/:municipality?', title: 'Personas contratadas'},
	{step: 4, url: '/informes/:modality/encuesta-calidad/:state?/:municipality?', title: 'Encuesta de satisfacción'},
	{step: 5, url: '/informes/:modality/resumen/:state?/:municipality?', title: 'Resumen general'}
]

export const revisionReportsInitNav = [
	{step: 1, url: '/revision/:modality/avance-fisico-financiero/:state?/:municipality?', title: 'Revision Avance físico financiero'},
	{step: 2, url: '/revision/:modality/gastos-coordinacion/:state?/:municipality?', title: 'Revision Gastos de coordinación'},
	{step: 3, url: '/revision/:modality/resumen/:state?/:municipality?', title: 'Resumen de informe'}
]

export const ETRANS = {
	pagination:{
		per_page:20
	},
	agencies: {
		types: {
			'federal': 'federal',
			'imef': 'imef',
			'imm': 'imm',
			'cdm': 'cdm'
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/config.js